document.addEventListener("DOMContentLoaded", () => {
  var num = $(".inside-product").length;

  var insideSwiper = new Swiper(".inside-product-list", {
    slidesPerView: 4,
    grid: {
      rows: num / 4,
    },
    spaceBetween: 15,
    pagination: {
      el: ".inside-pagination",
      clickable: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 4,
        grid: {
          rows: num / 4,
        },
      },
      501: {
        slidesPerView: 2,
        grid: {
          rows: num / 2,
        },
      },
      300: {
        slidesPerView: 1.3,
        grid: {
          rows: num / num,
        },
      },
    },
  });
});
